import type { AdSelectorOptionWithAsset2 } from '../../../../../apis/graphql';

export const isOptionAssetFilled = (option: AdSelectorOptionWithAsset2): boolean => {
  const { index, adSelectorVideoCreativeId, thumbnail, caption } = option;

  return !!index && !!adSelectorVideoCreativeId && !!thumbnail?.id && !!caption;
};
